export const spacingSquish = {
  xxs: '0.125rem 0.25rem',
  xs: '0.25rem 0.5rem',
  s: '0.5rem 1rem',
  m: '1rem 2rem',
  l: '1.5rem 3rem',
};
